import React from "react";
import { privacySections } from "../mock";
import { Seo } from "../components/Seo";

const PrivacyPolicyPage = () => {
  return (
    <div>
      <Seo
        title="Privacy Policy | OzzieeTech"
        description="How OzzieeTech collects, uses and protects your personal information across our website, contact forms and SEO Auto Engine."
        path="/privacy-policy"
      />
      <section className="relative pt-36 pb-16 bg-gradient-to-b from-slate-50 to-white overflow-hidden">
        <div className="absolute inset-0 grid-pattern opacity-60" />
        <div className="container-wide relative max-w-3xl">
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.18em] text-primary mb-3">Legal</span>
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900">Privacy Policy</h1>
          <p className="mt-4 text-slate-500 leading-relaxed">
            Your privacy matters to us. This policy explains what information we collect, how we use it, and the choices you have.
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="container-wide max-w-3xl space-y-10">
          {privacySections.map((s, i) => (
            <div key={s.title} className="relative pl-8">
              <span className="absolute left-0 top-1 flex h-6 w-6 items-center justify-center rounded-full bg-primary text-white text-xs font-bold">
                {i + 1}
              </span>
              <h2 className="font-display text-xl font-bold text-slate-900">{s.title}</h2>
              <p className="mt-2 text-slate-500 leading-relaxed">{s.body}</p>
            </div>
          ))}
          <p className="text-sm text-slate-400 pt-6 border-t border-slate-100">
            Last updated: 2024. This policy may be updated from time to time.
          </p>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;
